import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  Asortyment,
  asortymentResource,
} from "@megarax/client/src/resources/plm";
import { RouteConfig } from "vue-router";
import { revisionModuleRouteConfig } from "@/shared/resourceRouteConfig";

export const asortymentModule: ResourceAppModule = {
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  iconClass: "fas fa-tags fa-fw",
  app: plmApp,
  itemConstructor: Asortyment,
  resource: asortymentResource,
  route: "asortyment",
  title: "Asortymenty",
};
